(function (global){
var $ = global.jQuery = require('jquery')
var slick = require('slick-carousel');
var move = require('move-js');
var Snap = require('../../bower/snapjs/snap.min.js');
var Swiper = require('../../bower/swiper/dist/idangerous.swiper.min.js');
require('../../bower/fancybox/source/jquery.fancybox.pack.js');
var Parsley = require('parsleyjs');
var Cookies = require('cookies-js');

var hamburger = document.querySelector('.hamburger');
var magnify = document.querySelector('.magnify');
var search = document.querySelector('.search');
var searchClose = document.querySelector('.search .close');
var submenu = document.querySelector('.main .submenu');
var searchForm = document.getElementById('search-form');
var bodyClass = document.querySelector('body');
var isold = document.querySelector('html');
var snapper = new Snap({
    element: document.getElementById('content'),
    dragger: document.querySelector('nav.mobile'),
    disable: 'left',
    addBodyClasses: true,
    hyperextensible: false,
    resistance: 0.5,
    flickThreshold: 50,
    transitionSpeed: 0.2,
    easing: 'linear',
    maxPosition: 0,
    minPosition: -296,
    tapToClose: true,
    touchToDrag: false,
    slideIntent: 40,
    minDragDistance: 5
});

if($('html').hasClass("oldie")){
    isold = true;
} else {
    isold = false;
}

//Snapjs only if mobile/tablet
var browser = window;
var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight|| e.clientHeight|| g.clientHeight;

// On resize, update window sizes
if (x <= 962) {
    snapper.enable();
}else{
    snapper.disable();
}

// When window size changes
browser.onresize = function(){
    x = w.innerWidth || e.clientWidth || g.clientWidth;
    y = w.innerHeight|| e.clientHeight|| g.clientHeight;
    // If less than tablet size, snap!
    if (x < 962) {
        snapper.enable();
    }else{
        snapper.close();
        snapper.disable();
        if (!isold) {
            closeSubNav();
        }
    }
    //Update the newsbar
    if(bodyClass.className == 'home'){
        newsSwitcheroo.updateHeight();
    }
};

// Menu offseting
var doc = document.documentElement,
    left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
    top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0),
    mobmenu = document.querySelector('.mobile');
    // snapdata = snapper.state();

function docDim(){
    var body = document.body,
    html = document.documentElement;
    var winHeight = Math.max( body.scrollHeight, body.offsetHeight,
       html.clientHeight, html.scrollHeight, html.offsetHeight );
    return winHeight;
}

$(window).on('scroll', function(){
    // If the window is below the nav or above the end
    // animate menu to top of screen
    if(top.scrollY>74 && top.scrollY <= docDim()){
        mobmenu.style.top = scrollY - 74 + 'px';
    }else{
        // or don't
        mobmenu.style.top = 0;
    }
});

// Snap Menu Toggling
if(mobmenu){
    var m_sub = mobmenu.querySelectorAll('.main > li > a');
    for (var i = m_sub.length - 1; i >= 0; i--) {
        // Long check to see if parents sibling is a <UL>
        if(m_sub[i].parentNode.nextElementSibling && m_sub[i].parentNode.nextElementSibling.tagName == "UL"){
            m_sub[i].addEventListener('click', function(e){
                toggleMenulet(this);
                e.preventDefault();
            });
        };
    };
}

function toggleMenulet(el){
    var smenu = el.parentNode.nextElementSibling;
    if(hasClass(el, 'active')){
        removeClass(el,'active');
        move(smenu)
            .set('max-height', '0')
            .duration('.2s')
            .end();
    }else{
        addClass(el, 'active');
        move(smenu)
        .set('max-height', '999px')
        .duration('.4s')
        .end();
    }
};

// Contact page toggles
var rep_togs = document.querySelectorAll('.contact-reps .rep');
if(rep_togs){
    for (var i = 0; rep_togs.length > i; i++) {
        rep_togs[i].querySelector('.chevron-icon').addEventListener('click', function(e){
            e.preventDefault();
            toggleRep(this, this.parentNode.querySelector('.toggle'));
        });
    };
};

function toggleRep(parent, el) {
    if(!hasClass(el, 'open')){
    move(parent)
        .set('opacity', 0)
        .duration('.4s')
        .then()
            .set('opacity', 1)
            .pop()
        .end(function(){
            addClass(el, 'open');
            addClass(parent, 'open');
        });
    move(el)
        .set('max-height', '999px')
        .duration('.25s')
        .ease('ease-out')
        .end();
    }else{
        move(parent)
        .set('opacity', 0)
        .duration('.4s')
        .then()
            .set('opacity', 1)
            .pop()
        .end(function(){
            removeClass(el, 'open');
            removeClass(parent, 'open');
        });
        move(el)
            .set('max-height', '0px')
            .duration('.6s')
            .ease('ease-in')
            .end();
    }
}

// When esc key is pressed, hide things.
document.addEventListener('keydown', function(e) {
    var key = e.which || e.keyCode;
    if (key === 27) {
        snapper.close();
        closeSearch();
    }
});

hamburger.addEventListener('click', function(){
    if( snapper.state().state=="right" ){
        snapper.close();
    } else {
        snapper.open('right');
    }

});

if(isold){
    magnify.attachEvent("onclick", function(){
        if(hasClass(search, 'open')){
            closeSearch();
        }else{
            openSearch();
        }
    });
} else {
    magnify.addEventListener('click', function(){
        if($(search).hasClass('open')){
            closeSearch();
        }else{
            openSearch();
        }
    });
}

if(isold) {
    searchClose.attachEvent("onclick", function(){
        closeSearch();
    });
} else {
    searchClose.addEventListener('click', function(){
        closeSearch();
    });
}

if(isold){
    submenu.attachEvent("onclick", function(e){
        e.returnValue = false;
        toggleSubNav();
    });
} else {
    submenu.addEventListener('click', function(){
        toggleSubNav();
    });
}



function useSearch(e){
    var inputEl = searchForm.querySelector('input[type="text"]'),
    inputValue = inputEl.value.replace(/^\s+/, '').replace(/\s+$/, ''),
    that = searchForm;

    e.preventDefault();

    if (!!inputValue && typeof ga === 'function') {
        e.preventDefault();
        ga('send', 'event', 'Search', 'SubmitAttempt', 'Header', {
            hitCallback: function () {
                that.submit();
            }
        });
    }
}

// bind to search form submit to check whether anything has been entred in text input
if (searchForm) {
    if(!isold){
        searchForm.addEventListener('submit', function(e){
            useSearch(e);
        });
    } else {
        // IE >:L
        searchForm.attachEvent('submit', function(e) {
            useSearch(e);
        });
    }
}


function toggleSubNav() {
    var sub = document.querySelector('.sub');
    if(window.location.pathname.search("product") && hasClass(submenu.querySelector('a'), 'active') && sub.style.height == 0){
        if(!isold){
            move('.sub')
                .set('height', '490px')
                .duration('.4s')
                .ease('ease-out')
                .end();
        } else {
            sub.style.height = '490px';
        }
    }else{
        if(hasClass(submenu.querySelector('a'), 'active')){
            if(window.location.pathname.search("product") == -1){
                removeClass(submenu.querySelector('a'), 'active');
            }
            if(!isold){
                move('.sub')
                    .set('height', '')
                    .duration('.25s')
                    .end();
            } else {
                document.querySelector('.sub').style.height = 0;
            }
        }else{
            addClass(submenu.querySelector('a'), 'active');
            if (!isold) {
                move('.sub')
                    .set('height', '490px')
                    .duration('.4s')
                    .ease('ease-out')
                    .end();
            } else {
                document.querySelector('.sub').style.height = '490px';
            }
        }
    }
};

function closeSubNav() {
    removeClass(submenu.querySelector('a'), 'active');
    submenu.state = false;
    if(!isold){
        move('.sub')
            .set('height', '')
            .duration('.25s')
            .end();
    } else {
        document.querySelector('.sub').style.height = 0;
    }
};

window.onload = function() {
    var $slider = $('.swiper-wrapper');
    if ($slider){
        var homeSwiper = $slider.slick({
            // autoplay: true,
            autoplaySpeed: 10000,
            arrows: true,
            dots: true,
            appendDots: $('.pagination'),
            nextArrow: $('.next'),
            prevArrow: $('.prev')
        });
    }
    // Product slider and stuff =============================
    var prods = document.querySelector('.product-swiper');
    if(prods){
        var prod_slider = new Swiper(prods,{
            mode:'horizontal',
            loop: true,
            wrapperClass: 'product-wrapper',
            slideClass: 'prod-image',
            autoplayStopOnLast: true,
            paginationClickable: true,
            pagination: '.product-pagination',
            paginationElement: 'span',
            slideElement: 'div',
            paginationActiveClass: 'active'
        });
    }

    var sthumbs = document.querySelectorAll('.thumbnails img');
    for (i = 0;i < sthumbs.length; i++) {

        if(!i) {
            sthumbs[i].classList.add('active');
        }

        sthumbs[i].imgIndex = i;
        sthumbs[i].addEventListener("click", function(){
            gotoSlide(this);
        });
    };
    function gotoSlide(el) {
        [].forEach.call(sthumbs, function(thumb) {
            thumb.classList.remove('active');
        });
        prod_slider.swipeTo(el.imgIndex);
        el.classList.add('active');
    }

}

function openSearch(){
    addClass(search, 'open');
    if(!isold){
        move(search)
            .translate(0, 160)
            .set('opacity', '1')
            .duration('.25s')
            .ease('out')
            .end();
    } else {
        search.style.top = 0; 
    }
}

function closeSearch(){
    removeClass(search, 'open');
    if(!isold){
        move(search)
            .translate(0, -160)
            .set('opacity', '0')
            .duration('.4s')
            .end();
    } else {
        search.style.top = '-10em';
    }
}

// FAQ =========================================================================

var questions = document.querySelectorAll('.faq .question'),
tempQ = '';

for (var i = questions.length - 1; i >= 0; i--) {
    questions[i].addEventListener("click", function(e){
        e.preventDefault();
        toggleQA(this);
   });
};

function toggleQA(el) {
    var elem = el.querySelector('.ans'),
    link = el.querySelector('a');
    if(elem.open == true){
        //Close it!
        link.innerHTML = "+";
        move(elem)
            .set('max-height', '0')
            .ease('ease-out')
            .duration('.2s')
        .end();
        elem.open = false;
    }else{
        link.innerHTML = "–";
        move(elem)
            .set('max-height', '999px')
            .ease('ease-out')
            .duration('.5s')
            .end();
        elem.open = true;
    }
}

// Sales Reps on /sales =============

var reps = document.querySelectorAll('.togglebio');
if(reps){
    for(var i = 0; reps.length > i; i++) {
        reps[i].addEventListener('click', function(e){
            toggleBio(this);
            e.preventDefault();
        });
    }
}

function toggleBio(el) {
    var sib = el.nextElementSibling.nextElementSibling;
    if (sib.open == true){
        // Close bio
        sib.open = false;
        el.innerHTML = "Read Bio &raquo;"
        move(sib)
            .set('max-height', '0')
            .duration('.2s')
            .end()
    }else{
        //open bio
        el.innerHTML = "Close Bio &raquo;"
        move(sib)
            .set('max-height', '999px')
            .duration('.4s')
            .end()
        sib.open = true;
    }
}

var userImgs = document.querySelectorAll('.user-input img');
[].forEach.call(userImgs, function(img) {
    var alt = img.getAttribute('alt');

    if(!alt) {
        return;
    }

    img.setAttribute('title', alt);
});

// Contact form validations =============
// Using jQuery. Sue me.

window.ParsleyConfig = {
  errorsWrapper: '<span></span>',
  errorTemplate: '<p></p>'
};

// News switcheroo
var newsSwitcheroo = (function () {
    var articleHolder, articles, newsbannerH, newsSwitcher, newsCount;

    // Add first element to end to make seamless switch in dom
    // and a smooth animation
    function init() {
        articles = document.querySelectorAll(".newsbanner article");
        articleHolder = document.querySelector(".newsbanner .newsHolder"),
        newsbannerH = document.querySelector(".newsbanner").clientHeight,
        newsSwitcher = '',
        newsCount = 1;
        var toAppend = articles[0].cloneNode(true);
        articleHolder.appendChild(toAppend);
        // Update articles to reflect all the items
        articles = document.querySelectorAll(".newsbanner article");
        start();
    }


    // Start the animation
    function start() {
        newsSwitcher = setInterval(function () {
            if (newsCount >= articles.length - 1) {
                move(articleHolder)
                    .y(-(newsbannerH) * newsCount)
                    .duration(250)
                    .ease('ease-out-cubic')
                    .end(function () {
                        move(articleHolder)
                            .y(0)
                            .duration(0)
                            .end();
                    });
                newsCount = 1;
            } else {
                move(articleHolder)
                    .y(-(newsbannerH) * newsCount)
                    .duration(250)
                    .end();
                newsCount++;
            }
        }, 4500);
    };

    function fixAnimation(oldH, newH) {
        // Stop the animation from counting, reset to top and begin again
        if(!isold){
            clearInterval(newsSwitcher);
            move(articleHolder)
                .y(0)
                .duration(250)
                .end();
            newsCount = 1;
            start();
        }
    };

    // Update the height of the parent container
    // so the animation runs properly
    function updateHeight() {
        var height = document.querySelector(".newsbanner").clientHeight;
        if (height != newsbannerH) {
            // Send both heights to updating function
            fixAnimation(newsbannerH, height);
            newsbannerH = height;
        } else {
            newsbannerH = height;
        }
    };

    // For debugging or otherwise
    function getHeight() {
        console.log(newsbannerH);
        return newsbannerH;
    };

    return {
        init: init,
        start: start,
        getHeight: getHeight,
        updateHeight: updateHeight
    }
})();

if (bodyClass.classList == 'home') {
    newsSwitcheroo.init();
}

// Pretty much if !IE add share this
if(!isold) {
  var addthisel = document.createElement('script');
  addthisel.src= "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-53adaa316db5e050";
  addthisel.type = "text/javascript";
  document.body.appendChild(addthisel);
}


$('[data-aslider]').each(function(i, el) {

    $(this).on('init', function(event, slick){
        $(this).siblings('.A-year__slider-nav').find('.A-year__slider-count-total').html(slick.slideCount);
    });

    $(this).on('swipe afterChange', function(event, slick){
        $(this).siblings('.A-year__slider-nav').find('.A-year__slider-count-current').html(slick.currentSlide + 1);
    });

    $(this).slick({
        appendArrows: $(this).siblings('.A-year__slider-nav'),
        prevArrow: '<a class="A-year__slider-arrow A-year__slider-arrow--left" href="#"></a>',
        nextArrow: '<a class="A-year__slider-arrow A-year__slider-arrow--right href="#"></a>',
        fade: false
    });

});

$(document).ready(function() {
    $(".modal").fancybox({
        maxWidth    : 800,
        maxHeight   : 488,
        fitToView   : false,
        width       : '70%',
        height      : '70%',
        autoSize    : false,
        closeClick  : false,
        openEffect  : 'none',
        closeEffect : 'none'
    });
});

// Cookie Consent
var consent = Cookies.get('gdpr_consent')

if(!consent) {
    $('.cookieConsent').addClass('not-accepted');
    $('.cookieConsent__btn').click(function(e) {
        e.preventDefault();
        $('.cookieConsent').addClass('is-accepted');
        Cookies.set('gdpr_consent', true)
    })
}

// Util

function hasClass(el, selector) {
    return (" " + el.className + " ").indexOf(" " + selector + " ") > -1
}

function addClass(element, classname) {
    var cn = element.className;
    //test for existance
    if( cn.indexOf( classname ) != -1 ) {
        return;
    }
    //add a space if the element already has class
    if( cn != '' ) {
        classname = ' '+classname;
    }
    element.className = cn+classname;
}

function removeClass(element, classname) {
    var cn = element.className;
    var rxp = new RegExp( "\\s?\\b"+classname+"\\b", "g" );
    cn = cn.replace( rxp, '' );
    element.className = cn;
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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